<template>
  <div class="header-view">
    <!-- <b-tabs align="left" class="tabs-control">
      <template #title>
        <feather-icon icon="HomeIcon" />
        <span>Home</span>
      </template>
      <b-tab title="Apuração do caso COVAXIN" />
      <b-tab active title="(Sem Título)" />
      <b-tab title="(Sem Título)" />
    </b-tabs> -->

    <b-link
      v-if="canEdit"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-edit')"
      class="btn-sm btn-nav-link btn-nav-link-primary"
    >
      <feather-icon icon="EditIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Edit')}}</span>
    </b-link>

    <b-link
      v-if="canPublish"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-publish')"
      class="btn-sm btn-nav-link btn-nav-link-primary"
    >
      <feather-icon icon="CheckIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Publish')}}</span>
    </b-link>

    <b-link
      v-if="canStore"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-store')"
      class="btn-sm btn-nav-link btn-nav-link-white"
    >
      <feather-icon icon="SaveIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Save')}}</span>
    </b-link>

    <b-link
      v-if="canSchedule"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-schedule')"
      class="btn-sm btn-nav-link btn-nav-link-white"
    >
      <feather-icon icon="CalendarIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Schedule')}}</span>
    </b-link>

    <b-link
      v-if="canCancelEditing"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-cancel-editing')"
      class="btn-sm btn-nav-link btn-nav-link-white"
    >
      <feather-icon icon="XCircleIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Cancel_Editing')}}</span>
    </b-link>

    <b-link
      v-if="canErrata"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-errata')"
      class="btn-sm btn-nav-link btn-nav-link-white"
    >
      <feather-icon icon="EditIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Errata')}}</span>
    </b-link>

    <b-link
      v-if="canCopy"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-copy')"
      class="btn-sm btn-nav-link btn-nav-link-white"
    >
      <feather-icon icon="CopyIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Copy')}}</span>
    </b-link>

    <b-link
      v-if="canCancel"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-cancel')"
      class="btn-sm btn-nav-link btn-nav-link-white"
    >
      <feather-icon icon="TrashIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Cancel')}}</span>
    </b-link>

    <b-link
      v-if="canDisableNews"
      size="sm"
      :disabled="disabled"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="!disabled && $emit('action-disable')"
      class="btn-sm btn-nav-link btn-nav-link-white"
    >
      <feather-icon icon="EyeOffIcon" class="mr-50" />
      <span class="align-middle">{{$t('NEWS_ACTIONS.Disable')}}</span>
    </b-link>

    <!-- Botões dentro de um container posicionado onde os popovers são renderizados (ver "container" nos b-popover) -->
    <span v-if="isSendNews" :id="instance + 'popover-user-config-container'" class="popover-zoom-container">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        :id="instance + 'popover-user-config'"
        ref="user-config"
        size="sm"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        style="align-self: center;"
      >
        <feather-icon icon="SettingsIcon" />
      </b-button>
    </span>

    <span v-if="!isSendNews" id="popover-news-hist-container" class="popover-zoom-container">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        id="popover-news-hist"
        ref="popover-news-hist"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="flat-primary"
      >
        <feather-icon icon="SettingsIcon" />
      </b-button>
    </span>

   <!--  <b-button
      size="sm"
      class="btn-icon btn-close"
      variant="flat-primary"
      @click="$emit('close')"
    >
      <feather-icon icon="XIcon" title="Cancelar" />
    </b-button> -->

    <!-- POPOVER SENDNEWS DISPLAY FIELDS -->
    <b-popover
      v-if="isSendNews"
      :ref="instance + 'popover-user-config'"
      :target="instance + 'popover-user-config'"
      :container="instance + 'popover-user-config-container'"
      triggers="hover"
      :delay="{ show: 50, hide: 300 }"
      placement="bottom"
    >
      <!-- <b-form-group label="Opções de Tela" class="title-form">
        <div class="alert-body">
          <span
            ><strong>Aviso: </strong>Alguns elementos da tela podem ser exibidos
            ou ocultados usando as opções abaixo.</span
          >
        </div>
        <span class="alert"></span>
        <b-form-checkbox-group
          v-model="userConfig"
          :options="fieldConfig"
          value-field="field"
          text-field="name"
          class="row col-12"
          switches
        />
      </b-form-group> -->

      <change-zoom></change-zoom>
      <change-subject-view-type></change-subject-view-type>
    </b-popover>

    <!-- POPOVER DETAIL -->
    <b-popover
      v-if="!isSendNews"
      class="popover-news-hist"
      ref="popover-news-hist"
      target="popover-news-hist"
      container="popover-news-hist-container"
      triggers="hover"
      :delay="{ show: 50, hide: 300 }"
      placement="bottom"
    >
      <b-form-group label="Opções de Tela" class="title-form">
        <change-zoom></change-zoom>
        <clipboard-id :newsData="newsData"></clipboard-id>
        <div v-if="isAdmin || isEditor">
          <hr />
          <!-- <h6>{{ $t("SEND_NEWS.ReIndex_News") }}</h6>
          <b-button variant="flat-primary" class="btn-icon rounded-circle" @click.stop="$emit('reindex-news')">
            Refresh <feather-icon icon="RefreshCcwIcon" />
          </b-button> -->
          <h6>Elasticsearch</h6>
          <small v-if="newsData && newsData.elastic_excluded" class="d-block text-warning mb-50">
            Removida da busca por {{ newsData.elastic_excluded_by || '-' }}
            <span v-if="newsData.elastic_excluded_date">em {{ new Date(newsData.elastic_excluded_date).toLocaleString('pt-BR') }}</span>
          </small>
          <b-button v-if="newsData && newsData.elastic_excluded" variant="flat-primary" class="btn-icon rounded-circle" @click.stop="$emit('restore-elastic')">
            Restaurar <feather-icon icon="RotateCcwIcon" />
          </b-button>
          <b-button v-else variant="flat-primary" class="btn-icon rounded-circle" @click.stop="$emit('remove-elastic-from')">
            Remover <feather-icon icon="TrashIcon" />
          </b-button>
          <b-button variant="flat-primary" class="btn-icon rounded-circle" @click.stop="$emit('reindex-news')">
            Reindex <feather-icon icon="RefreshCcwIcon" />
          </b-button>
          <b-button variant="flat-primary" class="btn-icon rounded-circle" @click.stop="$emit('refresh-news')">
            Refresh <feather-icon icon="RefreshCcwIcon" />
          </b-button>
           <hr />
           <b-button variant="flat-primary" class="btn-icon rounded-circle" @click.stop="$emit('vectorize-news')">
              Vetorizar <feather-icon icon="RefreshCcwIcon" />
            </b-button>
        </div>
      </b-form-group>
      <!-- <manage-news-status-hist
        v-if="newsData.event_status_hist.length > 0"
        :newsData="newsData"
      ></manage-news-status-hist> -->
    </b-popover>
    
  </div>
</template>

<script>
import {
  BLink,
  BButton,
  BPopover,
  BFormCheckboxGroup,
  BFormGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import AppConstants from "@/appConstants";
import ChangeZoom from "@/views/components/ChangeZoom.vue";
import ChangeSubjectViewType from "@/views/components/ChangeSubjectViewType.vue";
import ClipboardId from "@/views/components/ClipboardId.vue";
// import ManageNewsStatusHist from "./manage/ManageNewsStatusHist.vue";

export default {
  data() {
    return {
      fieldConfig: AppConstants.USERCONFIG_SEND_NEWS,
      userConfig: [],
    };
  },
  created() {
    this.userConfig = this.$store.state.auth.currentUser.sendNewsConfig;
  },
  watch: {
    userConfig(val) {
      if (val) {
        this.$store.commit("auth/UPDATE_USER_CONFIG_SEND_NEWS", val);
      }
    },
  },
  props: {
    instance: {
      type: String
    },
    newsData: {
      type: Object,
      require: false,
    },
    event_status: {
      type: Number,
      require: true,
    },
    // Noticia em edicao que ja estava publicada: nao pode ser agendada
    isPublishedNews: {
      type: Boolean,
      default: false,
    },
    // Noticia aberta para edicao (status foi para editando): pode cancelar e voltar ao status anterior
    isEditingNews: {
      type: Boolean,
      default: false,
    },
    isSendNews: {
      type: Boolean,
      default: () => {
        false;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    Ripple,
  },
  components: {
    BLink,
    BButton,
    BPopover,
    /* eslint-disable */
    BFormCheckboxGroup,
    BFormGroup,
    ChangeZoom,
    ChangeSubjectViewType,
    ClipboardId
  },
  computed: {
    userData() {
      return this.$store.state.auth.currentUser || {};
    },
    isEditor() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.EDITOR) {
          return true;
        }
      }
      return false;
    },
    isAdmin() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.ADMIN) {
          return true;
        }
      }
      return false;
    },
    canDisableNews() {
      if (this.isSendNews) {
        return false;
      }
      return (
        this.event_status == AppConstants.EVENT_STATUS.PUBLISHED
      );
    },
    canCancel() {
      if (this.isSendNews) {
        return false;
      }
      if (this.event_status == AppConstants.EVENT_STATUS.TEMPLATE && (this.isAdmin || this.newsData.author.email == this.userData.email)) {
        return true;
      }
      return (
        this.event_status == AppConstants.EVENT_STATUS.SAVED ||
        this.event_status == AppConstants.EVENT_STATUS.SCHEDULED ||
        this.event_status == AppConstants.EVENT_STATUS.DRAFT
      );
    },
    canEdit() {
      if (this.isSendNews) {
        return false;
      }
      if (this.event_status == AppConstants.EVENT_STATUS.TEMPLATE && (this.isAdmin || this.newsData.author.email == this.userData.email)) {
        return true;
      }
      return (
        this.event_status == AppConstants.EVENT_STATUS.SAVED ||
        this.event_status == AppConstants.EVENT_STATUS.SCHEDULED ||
        this.event_status == AppConstants.EVENT_STATUS.DRAFT ||
        this.event_status == AppConstants.EVENT_STATUS.PUBLISHED &&
        this.newsData.layout != AppConstants.NEWS_LAYOUT.FLASHES
      );
    },
    canPublish() {
      if (this.isSendNews && this.event_status != AppConstants.EVENT_STATUS.TEMPLATE) {
        return true;
      }
      return (
        this.event_status == AppConstants.EVENT_STATUS.SAVED ||
        this.event_status == AppConstants.EVENT_STATUS.SCHEDULED 
      );
    },
    canSchedule() {
      if (this.isSendNews) {
        return this.event_status != AppConstants.EVENT_STATUS.TEMPLATE && !this.isPublishedNews;
      }
      return this.event_status == AppConstants.EVENT_STATUS.SAVED;
    },
    canStore() {
      if (this.isSendNews) {
        return true;
      }
      return (this.event_status == AppConstants.EVENT_STATUS.SCHEDULED);
    },
    canCancelEditing() {
      return this.isSendNews && this.isEditingNews;
    },
    canErrata() {
      if (this.isSendNews) {
        return false;
      }
      return this.event_status == AppConstants.EVENT_STATUS.PUBLISHED && (this.newsData.channel.findIndex(item => item.code == AppConstants.CHANNELS.LEGACY.id) >= 0);
    },
    canCopy() {
      if (this.isSendNews) {
        return false;
      }
      return this.event_status != AppConstants.EVENT_STATUS.DRAFT;
    },
  },
};
</script>

<style scoped>
.btn-nav-link[disabled] {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
